import { render, staticRenderFns } from "./Ordenes.vue?vue&type=template&id=6b9ee83a"
import script from "./Ordenes.vue?vue&type=script&lang=js"
export * from "./Ordenes.vue?vue&type=script&lang=js"
import style0 from "./Ordenes.vue?vue&type=style&index=0&id=6b9ee83a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports